// ============================================
// CUBE MULTIMEDIA - Complete Mock Data
// ============================================

export const cubeLogo = "https://res.cloudinary.com/drcoefnzk/image/upload/v1770800138/cube_white_logo_npn6np.png";

export const socialLinks = {
  facebook: "https://facebook.com/cubemultimedia.in",
  instagram: "https://instagram.com/cubemultimedia.in",
  youtube: "https://youtube.com/cubemultimedia",
  linkedin: "https://linkedin.com/company/cubemultimedia",
};

// Service category icon images - minimalist style
export const serviceCategoryIcons = {
  "digital-marketing": "https://static.prod-images.emergentagent.com/jobs/f6cc83ef-7afe-47db-8e73-72b9dcfa27dd/images/aacdb43d5aae60b68ec1f00eea12c805cc98fcb854bcf655ccdba549ff92c82a.png",
  "content-creation": "https://static.prod-images.emergentagent.com/jobs/f6cc83ef-7afe-47db-8e73-72b9dcfa27dd/images/eb877674180263ffce7b791e7b4e96eb71188a42ea4ead0b52eef484f37e4e10.png",
  "publicity-pr": "https://static.prod-images.emergentagent.com/jobs/f6cc83ef-7afe-47db-8e73-72b9dcfa27dd/images/71b103bccc7c3ed8c1801fbbabae02ad59a6b8ae87d87f726e12d97d0c09081c.png",
  "web-design-it": "https://static.prod-images.emergentagent.com/jobs/f6cc83ef-7afe-47db-8e73-72b9dcfa27dd/images/34dabe19972a8a23d7ecff6c48ff2f0a5e0add66c255288190ecdc522633c511.png",
  "trending": "https://static.prod-images.emergentagent.com/jobs/f6cc83ef-7afe-47db-8e73-72b9dcfa27dd/images/a9e4b304b9da4d89f89a827146fd4e6006be108aba3822557f3bce9bfb182140.png",
};

export const contactInfo = {
  office: "68, Roy Mallick Colony, Ghughudanga, Kolkata, West Bengal 700074",
  hours: "Mon to Sat, 10 AM to 7 PM",
  whatsapp: "+91 9046 965 841",
  email: "contact@cubemultimedia.in",
};

export const consultationLink = "https://cubemultimedia.dayschedule.com/11-marketing-strategy-call-with-senior-consultant";

export const aboutData = {
  tagline: "Cube Multimedia isn't just a marketing agency — it's a growth partner for brands that dream big.",
  description: "Born in Bengal and built with passion, Cube is redefining how creativity and strategy work together. From digital marketing and content creation to publicity, PR, and education — we help brands scale smarter with the right balance of storytelling, performance, and technology.",
  mission: "To simplify marketing and make creative growth accessible for every business — from startups to global brands.",
  vision: "To build Bengal's most trusted creative powerhouse that represents innovation, youth, and global thinking.",
  whoWeAre: "Cube Multimedia is more than just an agency — it's a creative ecosystem built to empower brands, creators, and businesses. We specialize in Digital Marketing, Content Creation, Publicity & PR, and IT Solutions, creating impact across every corner of the digital world.",
  founder: {
    name: "Sumanta Dey",
    title: "Founder & CEO",
    image: "https://res.cloudinary.com/di3uguh9s/image/upload/v1767021635/Team_Sumanta_dey_tpnrwr_pbuzcr.png",
    bio: "The visionary mind behind Cube's creative and marketing intelligence. Leading a passionate team of marketers, designers, filmmakers, and strategists to deliver cloud-first solutions for startups across India.",
    established: "2018",
    experience: "7+ Years",
  },
  stats: [
    { label: "Projects Completed", value: "500+" },
    { label: "Happy Clients", value: "200+" },
    { label: "Years Experience", value: "7+" },
    { label: "Cities Served", value: "15+" },
  ],
};

// ============================================
// SERVICE CATEGORIES & SUB-SERVICES
// ============================================

export const serviceCategories = [
  {
    id: "digital-marketing",
    title: "Digital Marketing",
    shortDesc: "Scale your brand with data-driven digital strategies",
    description: "From social media domination to paid ad mastery — we build digital marketing engines that drive real business growth. Our data-driven approach ensures every rupee spent delivers measurable ROI.",
    heroImage: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1200&q=80",
    color: "#dc2626",
    subServices: [
      {
        id: "social-media-management",
        title: "Social Media Management",
        description: "Complete social media management across Facebook, Instagram, YouTube, LinkedIn & Twitter. We handle everything from content strategy to daily posting, community engagement, and audience growth.",
        features: [
          "Daily posting on all platforms",
          "Content calendar & strategy",
          "Community engagement & moderation",
          "Follower growth & engagement boost",
          "Trend-based campaigns & hashtag strategy",
          "Monthly analytics & reporting",
        ],
        image: "https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?w=800&q=80",
      },
      {
        id: "performance-marketing",
        title: "Performance Marketing (Meta & Google Ads)",
        description: "High-ROI ad campaigns on Meta and Google platforms. We build, optimize, and scale paid campaigns that convert browsers into buyers with proven sales funnels.",
        features: [
          "Meta Ads & Google Ads campaigns",
          "Dedicated & proven sales funnels",
          "High ROI growth strategies",
          "Retargeting & lead nurturing",
          "Conversion rate optimization",
          "Audience segmentation & AI targeting",
        ],
        image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80",
      },
      {
        id: "influencer-marketing",
        title: "Influencer Marketing",
        description: "Partner with the right influencers to amplify your brand's reach and credibility. We connect you with verified creators who align with your brand values.",
        features: [
          "Influencer discovery & vetting",
          "Campaign strategy & execution",
          "Content collaboration management",
          "Performance tracking & ROI analysis",
          "Micro to macro influencer partnerships",
          "Brand ambassador programs",
        ],
        image: "https://images.unsplash.com/photo-1557804506-669a67965ba0?w=800&q=80",
      },
      {
        id: "whatsapp-api-marketing",
        title: "WhatsApp API Marketing",
        description: "Leverage WhatsApp Business API for direct customer communication, automated campaigns, and high-conversion messaging strategies.",
        features: [
          "WhatsApp Business API setup",
          "Broadcast messaging campaigns",
          "Automated chatbot flows",
          "Customer segmentation & targeting",
          "Order updates & notifications",
          "Lead generation via WhatsApp",
        ],
        image: "https://images.unsplash.com/photo-1611746872915-64382b5c76da?w=800&q=80",
      },
      {
        id: "google-my-business",
        title: "Google My Business Optimization",
        description: "Dominate local search results with optimized Google My Business profiles. We help you get found by customers actively searching for your services.",
        features: [
          "GMB profile setup & optimization",
          "Review management & response",
          "Local SEO integration",
          "Photo & post management",
          "Insights & analytics tracking",
          "Citation building & NAP consistency",
        ],
        image: "https://images.unsplash.com/photo-1573804633927-bfcbcd909acd?w=800&q=80",
      },
      {
        id: "marketing-automation",
        title: "Marketing Automation",
        description: "Set up intelligent marketing automation workflows that nurture leads, engage customers, and drive conversions on autopilot.",
        features: [
          "Email automation sequences",
          "Lead scoring & nurturing",
          "CRM integration & setup",
          "Workflow design & optimization",
          "Behavioral trigger campaigns",
          "Performance dashboards",
        ],
        image: "https://images.unsplash.com/photo-1518186285589-2f7649de83e0?w=800&q=80",
      },
    ],
  },
  {
    id: "content-creation",
    title: "Content Creation",
    shortDesc: "Creative visuals & stories that bring your brand to life",
    description: "From scroll-stopping reels to cinematic brand films — our creative team crafts content that captures attention, tells your story, and drives engagement across every platform.",
    heroImage: "https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?w=1200&q=80",
    color: "#f97316",
    subServices: [
      {
        id: "reels-production",
        title: "Reels Production",
        description: "Short-form video content that stops the scroll. We create viral-worthy reels for Instagram, YouTube Shorts, and TikTok that boost your brand visibility.",
        features: [
          "Concept & script development",
          "Professional shooting & lighting",
          "Trending audio & music selection",
          "Motion graphics & text overlays",
          "Platform-optimized formatting",
          "Batch production packages",
        ],
        image: "https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?w=800&q=80",
      },
      {
        id: "photography-videography",
        title: "Photography & Videography",
        description: "Professional photography and videography services for products, events, corporate shoots, and brand storytelling.",
        features: [
          "Product photography",
          "Corporate & event coverage",
          "Lifestyle & brand shoots",
          "Drone photography & videography",
          "Professional editing & retouching",
          "Studio & on-location shoots",
        ],
        image: "https://images.unsplash.com/photo-1554048612-b6a482bc67e5?w=800&q=80",
      },
      {
        id: "video-editing",
        title: "Video Editing",
        description: "Transform raw footage into compelling stories. Our editors deliver polished, engaging videos optimized for every platform and purpose.",
        features: [
          "Professional color grading",
          "Motion graphics & animations",
          "Sound design & mixing",
          "Subtitles & captions",
          "Multi-platform formatting",
          "Quick turnaround delivery",
        ],
        image: "https://images.unsplash.com/photo-1574717024453-354056aafa98?w=800&q=80",
      },
      {
        id: "graphics-design",
        title: "Graphics Design",
        description: "Eye-catching graphic design for social media, print, branding, and marketing collateral that visually represents your brand identity.",
        features: [
          "Social media creatives",
          "Brand identity & logo design",
          "Marketing collateral",
          "Presentation design",
          "Packaging design",
          "Infographics & data visualization",
        ],
        image: "https://images.unsplash.com/photo-1626785774573-4b799315345d?w=800&q=80",
      },
      {
        id: "brand-films",
        title: "Brand Films / Ad Films",
        description: "Cinematic brand films and ad films that tell your story with impact. From concept to final cut, we create visual masterpieces.",
        features: [
          "Concept & scriptwriting",
          "Pre-production planning",
          "Professional film crew",
          "Cinematic shooting",
          "Post-production & VFX",
          "Distribution strategy",
        ],
        image: "https://images.unsplash.com/photo-1485846234645-a62644f84728?w=800&q=80",
      },
    ],
  },
  {
    id: "publicity-pr",
    title: "Publicity & PR",
    shortDesc: "Build authority with strategic PR & media coverage",
    description: "From personal branding to national media coverage — we position you as the authority in your industry. Our PR strategies build credibility, trust, and visibility that money can't buy.",
    heroImage: "https://images.unsplash.com/photo-1504711434969-e33886168d6c?w=1200&q=80",
    color: "#a855f7",
    subServices: [
      {
        id: "personal-branding",
        title: "Personal Branding",
        description: "Build a powerful personal brand that positions you as a thought leader. We craft your online persona, content strategy, and visibility plan.",
        features: [
          "Personal brand strategy",
          "LinkedIn & social media optimization",
          "Thought leadership content",
          "Speaking engagement support",
          "Media appearance preparation",
          "Reputation management",
        ],
        image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&q=80",
      },
      {
        id: "media-news-pr",
        title: "Media News & PR Coverage",
        description: "Get featured in top media outlets and news platforms. We craft compelling press releases and manage media relations for maximum exposure.",
        features: [
          "Press release writing & distribution",
          "Media relationship management",
          "News coverage strategy",
          "Crisis communication",
          "Media kit creation",
          "Publication in top outlets",
        ],
        image: "https://images.unsplash.com/photo-1504711434969-e33886168d6c?w=800&q=80",
      },
      {
        id: "podcast-production",
        title: "Podcast Production & Marketing",
        description: "End-to-end podcast production from recording to distribution. We help you launch, grow, and monetize your podcast presence.",
        features: [
          "Podcast setup & equipment",
          "Recording & editing",
          "Show notes & descriptions",
          "Distribution on all platforms",
          "Podcast marketing & promotion",
          "Guest booking & management",
        ],
        image: "https://images.unsplash.com/photo-1590602847861-f357a9332bbc?w=800&q=80",
      },
      {
        id: "film-publicity",
        title: "Film Publicity Design",
        description: "Comprehensive film publicity and promotional design services for movie launches, trailers, and entertainment industry marketing.",
        features: [
          "Movie poster & banner design",
          "Trailer promotion strategy",
          "Social media film campaigns",
          "Press junket coordination",
          "Celebrity event management",
          "Entertainment PR coverage",
        ],
        image: "https://images.unsplash.com/photo-1478720568477-152d9b164e26?w=800&q=80",
      },
    ],
  },
  {
    id: "web-design-it",
    title: "Web Design & IT",
    shortDesc: "Modern websites & funnels that convert visitors into clients",
    description: "From stunning websites to high-converting landing pages — we build digital experiences that look incredible and perform even better. Every pixel is designed to convert.",
    heroImage: "https://images.unsplash.com/photo-1547658719-da2b51169166?w=1200&q=80",
    color: "#06b6d4",
    subServices: [
      {
        id: "website-design",
        title: "Website Design",
        description: "Custom website design and development that reflects your brand identity and drives business goals. Modern, responsive, and SEO-optimized.",
        features: [
          "Custom UI/UX design",
          "Responsive development",
          "SEO optimization",
          "CMS integration",
          "Performance optimization",
          "Ongoing maintenance & support",
        ],
        image: "https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?w=800&q=80",
      },
      {
        id: "landing-page-funnel",
        title: "Landing Page / Funnel Design",
        description: "High-converting landing pages and sales funnels designed to capture leads and drive conversions. A/B tested and optimized for maximum performance.",
        features: [
          "Conversion-optimized design",
          "A/B testing setup",
          "Lead capture forms",
          "Sales funnel architecture",
          "Analytics & tracking integration",
          "Speed & mobile optimization",
        ],
        image: "https://images.unsplash.com/photo-1522542550221-31fd19575a2d?w=800&q=80",
      },
    ],
  },
  {
    id: "trending",
    title: "Others Trending",
    shortDesc: "Stay ahead with AI tools, consultancy & workshops",
    description: "Stay ahead of the curve with cutting-edge services. From AI integration to hands-on workshops, we help businesses embrace the future of marketing and technology.",
    heroImage: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=1200&q=80",
    color: "#10b981",
    subServices: [
      {
        id: "marketing-consultancy",
        title: "Marketing & Sales Consultancy",
        description: "Expert marketing and sales consultancy to help you build scalable growth strategies. We analyze, strategize, and guide your business toward measurable success.",
        features: [
          "Business & market analysis",
          "Growth strategy development",
          "Sales process optimization",
          "Competitive intelligence",
          "Revenue forecasting",
          "Ongoing advisory support",
        ],
        image: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=800&q=80",
      },
      {
        id: "ai-tools-integration",
        title: "AI Tools Integration",
        description: "Integrate cutting-edge AI tools into your business workflow. From ChatGPT to custom automation, we help you work smarter and faster.",
        features: [
          "AI tool selection & setup",
          "Workflow automation",
          "ChatGPT & AI integration",
          "Custom AI solutions",
          "Team training on AI tools",
          "Productivity optimization",
        ],
        image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&q=80",
      },
      {
        id: "training-workshops",
        title: "Training & Workshops",
        description: "Hands-on training and workshops for teams and individuals. Learn digital marketing, content creation, and AI tools from industry experts.",
        features: [
          "Digital marketing masterclass",
          "Content creation workshops",
          "Social media training",
          "AI & automation workshops",
          "Corporate training programs",
          "One-on-one mentorship",
        ],
        image: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=800&q=80",
      },
    ],
  },
];

// Flat list of all sub-services for search
export const allSubServices = serviceCategories.flatMap((cat) =>
  cat.subServices.map((sub) => ({
    ...sub,
    categoryId: cat.id,
    categoryTitle: cat.title,
    categoryColor: cat.color,
  }))
);

// ============================================
// TESTIMONIALS
// ============================================

export const testimonials = [
  {
    id: 1,
    name: "Divya Trivedi",
    initial: "D",
    review: "Amazing work on our social media pages! The creativity, consistency, and strategy have boosted our engagement massively. Truly impressed with the dedication!",
    rating: 5,
    service: "Social Media Management",
  },
  {
    id: 2,
    name: "Shilesh Bhattacharya",
    initial: "S",
    review: "Exceptional digital marketing service! The team explained the entire strategy clearly, from content planning to ad optimisation. Very efficient and reliable — highly recommended!",
    rating: 5,
    service: "Digital Marketing",
  },
  {
    id: 3,
    name: "Rishman Enterprises",
    initial: "R",
    review: "We ran Google Ads campaigns with them, and the results were outstanding. Their flexibility, prompt updates, and constant optimisation made a huge difference.",
    rating: 5,
    service: "Performance Marketing",
  },
  {
    id: 4,
    name: "Rajan Dhirvi",
    initial: "R",
    review: "Big shoutout for managing our social media and ad campaigns so seamlessly! Their dedication, detailed analytics, and creative execution made everything effortless for us.",
    rating: 5,
    service: "Social Media Management",
  },
  {
    id: 5,
    name: "Shirey Shah",
    initial: "S",
    review: "Great experience working with the team for social media management! Their content quality, regular updates, and understanding of brand voice stood out. Definitely recommend!",
    rating: 5,
    service: "Content Creation",
  },
  {
    id: 6,
    name: "Ankit Verma",
    initial: "A",
    review: "We scaled our business online with their guidance. From running high-ROI Google Ads to handling our social media content professionally — they managed everything smoothly.",
    rating: 5,
    service: "Performance Marketing",
  },
];

// ============================================
// TRUSTED BRANDS
// ============================================

export const trustedBrands = [
  { name: "Mamaearth", logo: "https://res.cloudinary.com/drcoefnzk/image/upload/v1773048144/6CUBE-CLIENT-LOGOAnushree-Malhotra_copy_goaqxe.png", size: "large" },
  { name: "Lenskart", logo: "https://res.cloudinary.com/drcoefnzk/image/upload/v1773048143/4CUBE-CLIENT-LOGOAnushree-Malhotra_copy_krkolr.png", size: "large" },
  { name: "Client 6", logo: "https://res.cloudinary.com/drcoefnzk/image/upload/v1773048143/5CUBE-CLIENT-LOGOAnushree-Malhotra_copy_vgpzr0.png" },
  { name: "Anushree Malhotra", logo: "https://res.cloudinary.com/drcoefnzk/image/upload/v1773048143/CUBE-CLIENT-LOGOAnushree-Malhotra_thtz47.png", size: "large" },
  { name: "Client 8", logo: "https://res.cloudinary.com/drcoefnzk/image/upload/v1773048146/2CUBE-CLIENT-LOGOAnushree-Malhotra_copy_sjxhbp.png" },
  { name: "Kidzee", logo: "https://res.cloudinary.com/drcoefnzk/image/upload/v1773047124/CUBE-CLIENT-LOGOKIDZEE_dwscmu.png" },
  { name: "Zee Music Company", logo: "https://res.cloudinary.com/drcoefnzk/image/upload/v1773047123/CUBE-CLIENT-LOGOZee_Music_Company_f3fypv.png" },
  { name: "Workzone", logo: "https://res.cloudinary.com/drcoefnzk/image/upload/v1773047123/CUBE-CLIENT-LOGOWorkzone_dgbecs.png", size: "large" },
  { name: "TufconXT", logo: "https://res.cloudinary.com/drcoefnzk/image/upload/v1773047121/CUBE-CLIENT-LOGOTufconXT_dnicpa.png", size: "large" },
  { name: "RM Films", logo: "https://res.cloudinary.com/drcoefnzk/image/upload/v1773047121/CUBE-CLIENT-LOGORM-Films_ftkjko.png", size: "large" },
  { name: "Plate on the Wheels", logo: "https://res.cloudinary.com/drcoefnzk/image/upload/v1773047120/CUBE-CLIENT-LOGOPlate-on-the_wheels_opkkqj.png", size: "large" },
  { name: "P Leathers", logo: "https://res.cloudinary.com/drcoefnzk/image/upload/v1773047119/CUBE-CLIENT-LOGOP-Leathers-Logo_caqx2j.png", size: "large" },
  { name: "Beyond Podcast", logo: "https://res.cloudinary.com/drcoefnzk/image/upload/v1773047118/CUBE-CLIENT-LOGOBeyond-Podcast_leoht0.png", size: "large" },
  { name: "Saltlake Academy", logo: "https://res.cloudinary.com/drcoefnzk/image/upload/v1773048373/CUBE-CLIENT-LOGOLakeme_tsrav0.png", size: "large" },
];

// ============================================
// CELEBRITY IMAGES
// ============================================

export const celebrityImages = [
  { id: 1, src: "https://res.cloudinary.com/drcoefnzk/image/upload/v1771793862/533555372_2814811298704740_6656684040750433159_n_qlbzta.jpg" },
  { id: 2, src: "https://res.cloudinary.com/drcoefnzk/image/upload/v1771793861/540969214_2828063207379549_6587242500618745164_n_nqhn3b.jpg" },
  { id: 3, src: "https://res.cloudinary.com/drcoefnzk/image/upload/v1771793861/508180400_2760122727506931_5786770138739285379_n_i65awh.jpg" },
  { id: 4, src: "https://res.cloudinary.com/drcoefnzk/image/upload/v1771793861/542684271_2831072703745266_3774876302105602767_n_qxm7dt.jpg" },
  { id: 5, src: "https://res.cloudinary.com/drcoefnzk/image/upload/v1771793862/541524631_18199516492311876_982446660130278670_n_wcfylf.jpg" },
  { id: 6, src: "https://res.cloudinary.com/drcoefnzk/image/upload/v1773050632/ss_taxvz5.jpg" },
  { id: 7, src: "https://res.cloudinary.com/drcoefnzk/image/upload/v1773049486/469902322_18173202076311876_6710513313353400940_n_mjfrco.jpg" },
  { id: 8, src: "https://res.cloudinary.com/drcoefnzk/image/upload/v1773049485/485179210_2670069886512216_543571954368961138_n_pnewfg.jpg" },
  { id: 9, src: "https://res.cloudinary.com/drcoefnzk/image/upload/v1771793862/512744367_2769203286598875_7406091272587388336_n_tvso6a.jpg" },
  { id: 10, src: "https://res.cloudinary.com/drcoefnzk/image/upload/v1771793863/540163031_18199516483311876_7533284773458176772_n_vydgyo.jpg" },
  { id: 11, src: "https://res.cloudinary.com/drcoefnzk/image/upload/v1771793863/539825898_18199310125311876_8947678989536175071_n_ngread.jpg" },
  { id: 12, src: "https://res.cloudinary.com/drcoefnzk/image/upload/v1771793863/545104942_2837385026447367_6538773560208218213_n_quxadr.jpg" },
  { id: 13, src: "https://res.cloudinary.com/drcoefnzk/image/upload/v1771793863/536747950_2822751211244082_1316518151416880390_n_cpr9xc.jpg" },
  { id: 14, src: "https://res.cloudinary.com/drcoefnzk/image/upload/v1771793863/550520624_2851677791684757_4927085036061889612_n_gxotgx.jpg" },
  { id: 15, src: "https://res.cloudinary.com/drcoefnzk/image/upload/v1771793863/614221356_2956961581156377_7014735608589682287_n_wbcwe6.jpg" },
  { id: 16, src: "https://res.cloudinary.com/drcoefnzk/image/upload/v1771793866/615181463_2956961414489727_4712048534653901_n_tqke8o.jpg" },
  { id: 17, src: "https://res.cloudinary.com/drcoefnzk/image/upload/v1773049092/588627863_18211701688311876_7456030275862393755_n_zgwuvl.jpg" },
  { id: 18, src: "https://res.cloudinary.com/drcoefnzk/image/upload/v1773049097/BBD1_n2edsn.jpg" },
  { id: 19, src: "https://res.cloudinary.com/drcoefnzk/image/upload/v1773049093/591146716_18211701679311876_5109896558038048499_n_agdbr1.jpg" },
  { id: 20, src: "https://res.cloudinary.com/drcoefnzk/image/upload/v1773049489/487212786_2682490565270148_168059368801355951_n_dqwgpa.jpg" },
  { id: 21, src: "https://res.cloudinary.com/drcoefnzk/image/upload/v1773049490/586760815_18210586666311876_4294758540435119007_n_lvjlch.jpg" },
  { id: 22, src: "https://res.cloudinary.com/drcoefnzk/image/upload/v1773049492/503864030_18191051767311876_6913724385220305374_n_j81whk.jpg" },
  { id: 23, src: "https://res.cloudinary.com/drcoefnzk/image/upload/v1773049493/503928480_18191051749311876_4034284495712835078_n_yjzoi2.jpg" },
  { id: 24, src: "https://res.cloudinary.com/drcoefnzk/image/upload/v1773049495/634455016_2991759211009947_1985265336656931190_n_ocupow.jpg" },
  { id: 25, src: "https://res.cloudinary.com/drcoefnzk/image/upload/v1773049822/Golpo_Hok_poster_rupanjana_2_vxbcrh.jpg" },
];

// ============================================
// PORTFOLIO MOCK (placeholder for real content)
// ============================================

export const portfolioItems = [
  {
    id: 1,
    title: "Social Media Campaign - Fashion Brand",
    type: "image",
    category: "digital-marketing",
    thumbnail: "https://images.unsplash.com/photo-1611162616305-c69b3fa7fbe0?w=400&q=80",
  },
  {
    id: 2,
    title: "Brand Film - Startup Launch",
    type: "video",
    category: "content-creation",
    thumbnail: "https://images.unsplash.com/photo-1536240478700-b869070f9279?w=400&q=80",
    videoUrl: "",
  },
  {
    id: 3,
    title: "Google Ads Campaign - E-commerce",
    type: "image",
    category: "digital-marketing",
    thumbnail: "https://images.unsplash.com/photo-1563986768494-4dee2763ff3f?w=400&q=80",
  },
  {
    id: 4,
    title: "Personal Branding - CEO Profile",
    type: "image",
    category: "publicity-pr",
    thumbnail: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&q=80",
  },
  {
    id: 5,
    title: "Website Redesign - Real Estate",
    type: "image",
    category: "web-design-it",
    thumbnail: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&q=80",
  },
  {
    id: 6,
    title: "Reels Production - Food Brand",
    type: "video",
    category: "content-creation",
    thumbnail: "https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?w=400&q=80",
    videoUrl: "",
  },
];

// ============================================
// YOUTUBE VIDEOS - Client Feedback & Content
// ============================================

export const landscapeVideos = [
  {
    id: "cube-ad-leads",
    title: "How to Get More Sales / Leads using Social Media",
    youtubeId: "2ovxeSQeaHo",
    type: "ad",
    category: "digital-marketing",
  },
  {
    id: "pleathers-feedback",
    title: "PLeathers - Footwear Brand Feedback",
    youtubeId: "TYtrE9tCuuA",
    type: "feedback",
    category: "digital-marketing",
  },
  {
    id: "anand-krishi-feedback",
    title: "Anand Krishi Khamar - Fish Farming Company Feedback",
    youtubeId: "cLqbxHR31fQ",
    type: "feedback",
    category: "digital-marketing",
  },
  {
    id: "tally-academy-feedback",
    title: "Sumanta Dey - Building Cube Multimedia",
    youtubeId: "X1zmROSj8V0",
    type: "feedback",
    category: "digital-marketing",
  },
  {
    id: "dolls-heaven-feedback",
    title: "Dolls Heaven - Travel Agency Feedback",
    youtubeId: "4OSdjAJ8hHM",
    type: "feedback",
    category: "digital-marketing",
  },
];

// Founder Journey Videos - Sumanta Dey
export const founderVideos = [
  {
    id: "sumanta-journey-1",
    title: "Sumanta Dey - My Journey at Cube Multimedia",
    youtubeId: "_D1J3TMM598",
    description: "Watch our Founder & CEO share his inspiring journey building Cube Multimedia from the ground up.",
  },
  {
    id: "sumanta-journey-2",
    title: "Sumanta Dey - Building Cube Multimedia",
    youtubeId: "X1zmROSj8V0",
    description: "The story behind Cube Multimedia and the vision that drives us forward.",
  },
];

export const shortsVideos = [
  {
    id: "ahana-english",
    title: "Ahana Easy English Feedback",
    youtubeId: "VeguCX70Woc",
    industry: "Education",
  },
  {
    id: "prasenjit-sastri",
    title: "Astrologer Prasenjit Sastri Feedback",
    youtubeId: "CS_jVsaxKT8",
    industry: "Astrologer",
  },
  {
    id: "aditya-narayan",
    title: "Sree Aditya Narayan Feedback",
    youtubeId: "DvcPhk6y1mU",
    industry: "Astrologer",
  },
  {
    id: "kidzee",
    title: "Kidzee Feedback",
    youtubeId: "gSJ7gr_DMPw",
    industry: "Education",
  },
  {
    id: "anushree-malhotra",
    title: "Anushree Malhotra - Fashion Designer Feedback",
    youtubeId: "A1DqCDNyfYM",
    industry: "Fashion",
  },
  {
    id: "kritanjali",
    title: "Kritanjali Boutique Feedback",
    youtubeId: "locCycmAqMA",
    industry: "Boutique",
  },
  {
    id: "storybizz-1",
    title: "Storybizz PR Agency Feedback",
    youtubeId: "WHGbU-9XE00",
    industry: "PR Agency",
  },
  {
    id: "storybizz-2",
    title: "Storybizz PR Agency Feedback 2",
    youtubeId: "vrPB2q6QxeA",
    industry: "PR Agency",
  },
  {
    id: "tally-academy-short",
    title: "Tally Academy Sodepur Feedback",
    youtubeId: "okD8j1kC8VM",
    industry: "Education",
  },
  {
    id: "cube-ugc-1",
    title: "Cube Client Feedback",
    youtubeId: "ueKWExCTqvM",
    industry: "Client Feedback",
  },
  {
    id: "cube-ugc-2",
    title: "Cube Client Feedback",
    youtubeId: "XBWWM3gyqLs",
    industry: "Client Feedback",
  },
  {
    id: "cube-ugc-3",
    title: "Cube Client Feedback",
    youtubeId: "2Kw34k5vu0k",
    industry: "Client Feedback",
  },
  {
    id: "lakme-vlog",
    title: "Lakme Social Media Content Shoot Vlog",
    youtubeId: "Mmo1Gy6WwP0",
    industry: "Content",
  },
  {
    id: "shankar-chakraborty",
    title: "Actor Shankar Chakraborty wishing Cube",
    youtubeId: "38wt2tZYUak",
    industry: "Celebrity",
  },
  {
    id: "aishwariya-wish",
    title: "Actress Aishwariya wishing Cube audience",
    youtubeId: "rxPD6yD-idw",
    industry: "Celebrity",
  },
];

export const podcastData = {
  name: "Golpo Hok",
  host: "Sumanta Dey",
  channelUrl: "https://www.youtube.com/@thesumantadey",
  description: "Real stories, real conversations. A podcast by Cube CEO Sumanta Dey covering entrepreneurship, creativity, and inspiring journeys.",
};
